var React = require('react');

function FiltersIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.50171 4H0.695312V1.33333H7.50171V4ZM7.50171 8H0.695312V10.6667H7.50171V8ZM26.0015 17.3333L20.7878 12.2267C19.6988 12.92 18.4192 13.3333 17.0307 13.3333C13.2735 13.3333 10.2243 10.3467 10.2243 6.66667C10.2243 2.98667 13.2735 0 17.0307 0C20.7878 0 23.837 2.98667 23.837 6.66667C23.837 8.02667 23.4151 9.28 22.7072 10.3333L27.9209 15.4533L26.0015 17.3333ZM21.1145 6.66667C21.1145 4.46667 19.2768 2.66667 17.0307 2.66667C14.7845 2.66667 12.9468 4.46667 12.9468 6.66667C12.9468 8.86667 14.7845 10.6667 17.0307 10.6667C19.2768 10.6667 21.1145 8.86667 21.1145 6.66667ZM0.695312 17.3333H14.3081V14.6667H0.695312V17.3333Z","fill":"#004989"}));
}

FiltersIcon.defaultProps = {"width":"28","height":"18","viewBox":"0 0 28 18","fill":"none"};

module.exports = FiltersIcon;

FiltersIcon.default = FiltersIcon;
